import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { useAtom } from 'jotai';
import { useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import LargeCard from '@/components/LargeCard';
import { ticketAtom, ticketIsEditingAtom } from '@/pages/Ticket';

import TicketCreateExternalThreats from '../TicketCreateExternalThreats';
import useStyles from './TicketCreateThreatDetails.styles';

const TicketCreateThreatDetails = () => {
  const [{ ip_address, detected_at }] = useAtom(ticketAtom);
  const [ticketIsEditing] = useAtom(ticketIsEditingAtom);
  const { control, setValue } = useFormContext();

  const { classes } = useStyles();

  // if user reloads the page while editing
  useEffect(() => {
    if (ticketIsEditing) {
      setValue('ip_address', ip_address);
      setValue('detected_at', dayjs.utc(detected_at).local());
    }
  }, [ip_address, detected_at, setValue, ticketIsEditing]);

  return (
    <LargeCard title="Threat Details">
      <Stack direction="column" spacing={2}>
        <Stack direction="row" spacing={3}>
          <div className={classes.threatDetailsFormElement}>
            <InputLabel htmlFor="detected-picker">Detected At *</InputLabel>
            <FormControl id="detected-picker" fullWidth>
              <Controller
                control={control}
                name="detected_at"
                rules={{
                  required: true,
                  validate: (value) => dayjs(value).isValid()
                }}
                render={({ field, formState }) => (
                  <DateTimePicker
                    slotProps={{
                      textField: {
                        error: !!formState.errors.detected_at
                      },
                      actionBar: {
                        sx: {
                          backgroundColor: 'var(--mui-palette-background-paper)'
                        }
                      }
                    }}
                    {...field}
                  />
                )}
              />
            </FormControl>
          </div>
        </Stack>
        <div>
          <TicketCreateExternalThreats />
        </div>
      </Stack>
    </LargeCard>
  );
};

export default TicketCreateThreatDetails;
